export const CALENDLY_URL = 'https://calendly.com/smarterqueue-customer-success/onboarding-call';
